module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-page shop-page-qr"
  }, [_c('div', {
    staticClass: "foo shop-page__header"
  }, [_c('div', {
    staticClass: "shop-page__header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_ci_shop')) + " QR")]), _vm._v(" "), _c('p', {
    staticClass: "shop-page__subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_shop_qr')) + " / Tablet")])]), _vm._v(" "), _c('div', {
    staticClass: "shop-page__header-actions"
  }, [_c('button', {
    staticClass: "new-button shop-page-qr__fullscreen-btn",
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('i', {
    class: _vm.isFullscreen ? 'ti-close' : 'ti-fullscreen'
  }), _vm._v("\n        " + _vm._s(_vm.isFullscreen ? _vm.locale.t('label_exit_fullscreen') : _vm.locale.t('label_enter_fullscreen')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-pos-page"
  }, [_c('div', {
    staticClass: "content-shop"
  }, [_c('div', {
    staticClass: "shop-page__search shop-page-qr__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopSearch),
      expression: "shopSearch"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search') + '...'
    },
    domProps: {
      "value": (_vm.shopSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shopSearch = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.categoryChips.length > 0) ? _c('div', {
    staticClass: "scrollmenu scrollmenu-spaced shop-page-qr__chips"
  }, [_c('span', {
    staticClass: "chips-group clickable",
    on: {
      "click": function($event) {
        return _vm.selectCategoryChip('all')
      }
    }
  }, [_c('span', {
    staticClass: "single-chip"
  }, [_c('span', {
    class: _vm.isCategorySelected('all') ? 'chip-selected' : 'chip-unselected'
  }, [_vm._v("\n              " + _vm._s(_vm.isCategorySelected('all') ? '✔ ' : '') + _vm._s(_vm.locale.t('label_all')) + "\n            ")])])]), _vm._v(" "), _vm._l((_vm.categoryChips), function(item) {
    return _c('span', {
      key: item,
      staticClass: "chips-group clickable",
      on: {
        "click": function($event) {
          return _vm.selectCategoryChip(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.isCategorySelected(item) ? 'chip-selected' : 'chip-unselected'
    }, [_vm._v("\n              " + _vm._s(_vm.isCategorySelected(item) ? '✔ ' : '') + _vm._s(item) + "\n            ")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "products shop-products"
  }, [_c('div', {
    staticClass: "grid shop-grid shop-page-qr__grid"
  }, _vm._l((_vm.filteredShopItems), function(item) {
    return _c('article', {
      key: item.id,
      staticClass: "tile shop-tile shop-page-qr__tile",
      class: {
        'is-hidden': item.hidden
      },
      on: {
        "click": function($event) {
          return _vm.onShopItemClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "tile-top"
    }, [_c('div', {
      staticClass: "tile-name"
    }, [_vm._v("\n                " + _vm._s(_vm.getCompanyInfoName(item)) + "\n                "), (item.discountPrice != null && item.discountPrice.length > 0) ? _c('b', {
      staticClass: "discount-label"
    }, [_vm._v("\n                  -" + _vm._s(item.addInfo.discount) + "%\n                ")]) : _vm._e()]), _vm._v(" "), (item.discountPrice != null && item.discountPrice.length > 0) ? _c('div', {
      staticClass: "tile-price"
    }, [_c('s', [_vm._v(_vm._s(_vm.money(item.price, item.addInfo.currency)))]), _c('br'), _vm._v(" "), _c('b', {
      staticClass: "shop-price-strike"
    }, [_vm._v(_vm._s(item.discountPrice))]), _vm._v(" "), _c('b', {
      staticClass: "shop-price-strike"
    }, [_vm._v(_vm._s(item.addInfo.currency))])]) : _c('div', {
      staticClass: "tile-price"
    }, [_vm._v(_vm._s(_vm.money(item.price, item.addInfo.currency)))])]), _vm._v(" "), _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": item.imageMain,
        "alt": "product image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tile-bottom"
    }, [_c('span', {
      staticClass: "badge",
      class: _vm.stockClass(item)
    }, [_vm._v(_vm._s(_vm.stockLabel(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "tile-actions shop-page-qr__actions"
    }, [_c('button', {
      staticClass: "action-btn shop-page-qr__qr-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showQrCodeForItem(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_shop_qr')) + "\n              ")])])])
  }), 0), _vm._v(" "), (_vm.filteredShopItems.length === 0) ? _c('div', {
    staticClass: "shop-page-qr__empty"
  }, [_vm._v("\n          " + _vm._s(_vm.locale.t('label_no_data')) + "\n        ")]) : _vm._e()])])]), _vm._v(" "), _c('show-qr-code-dialog', {
    attrs: {
      "show": _vm.showQrCodeItem != null,
      "item": _vm.showQrCodeItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a95ff598!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop/ShopPageQr.vue
// module id = 816
// module chunks = 0